/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedModelDestinatarioRicercaDTO } from '../model/paged-model-destinatario-ricerca-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    ComunicazioniManualiDestinatariServiceInterface,
    CercaDestinatariComunicazioneRequestParams
} from './comunicazioni-manuali-destinatari.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class ComunicazioniManualiDestinatariService extends BaseService implements ComunicazioniManualiDestinatariServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Cerca cittadini destinatari di una comunicazione (SUPERADMIN, OP_COMUNE).
     * Ricerca per nome, cognome o email (sottostringa, senza distinzione fra maiuscole e minuscole) fra i cittadini che il caller puo\&#39; contattare. Con &#x60;q&#x60; assente o di meno di 2 caratteri la pagina e\&#39; vuota. Ordine fisso cognome, nome; pagina di massimo 20 righe.  Perimetro: mai anonimizzati, bloccati o con account non attivato. Per un OP_COMUNE solo cittadini con almeno una pratica su un bando del comune di perimetro (&#x60;comune_id&#x60;: obbligatorio se gestisce piu\&#39; comuni, default se ne gestisce uno). Per un SUPERADMIN &#x60;comune_id&#x60; e\&#39; opzionale e, se presente, applica lo stesso vincolo.  L\&#39;email e\&#39; restituita per intero (&#x60;email&#x60;); &#x60;n_dispositivi&#x60; dice a quanti dispositivi arriverebbe una push.  Risposte: - 200: &#x60;Page&lt;DestinatarioRicercaDTO&gt;&#x60;. - 400: &#x60;comune_id&#x60; mancante per un OP_COMUNE con piu\&#39; comuni. - 403: caller ne\&#39; SUPERADMIN ne\&#39; OP_COMUNE. - 404: comune inesistente o fuori dai comuni gestiti.
     * @endpoint get /api/v1/gestione/comunicazioni-manuali/destinatari
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public cercaDestinatariComunicazione(requestParameters: CercaDestinatariComunicazioneRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelDestinatarioRicercaDTO>;
    public cercaDestinatariComunicazione(requestParameters: CercaDestinatariComunicazioneRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelDestinatarioRicercaDTO>>;
    public cercaDestinatariComunicazione(requestParameters: CercaDestinatariComunicazioneRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelDestinatarioRicercaDTO>>;
    public cercaDestinatariComunicazione(requestParameters: CercaDestinatariComunicazioneRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling cercaDestinatariComunicazione.');
        }
        const q = requestParameters?.q;
        const comuneId = requestParameters?.comuneId;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'q',
            <any>q,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'comune_id',
            <any>comuneId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/comunicazioni-manuali/destinatari`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelDestinatarioRicercaDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
